import { useEffect } from 'react';
import { useCarOperations } from './useCarOperations';
import { useIsAutorizedUser } from 'store/features/auth';

export const useInitADRClasses = () => {
  const { getADRClasses } = useCarOperations();
  const isAutorizedUser = useIsAutorizedUser();

  useEffect(() => {
    if (isAutorizedUser) {
      getADRClasses();
    }
  }, [
    isAutorizedUser,
    getADRClasses
  ]);
};
